import React, { Fragment, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CircularProgress from '@mui/material/CircularProgress';
import CopyrightIcon from '@mui/icons-material/Copyright';
import DoneIcon from '@mui/icons-material/Done';
import ReplyAllIcon from '@mui/icons-material/ReplyAll';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData, postData} from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import Select from 'react-select';
import { Tooltip } from '@mui/material';
import Modal from '@mui/material/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';


const ItemCreate = (props) => {
    const history = useHistory();
    const { isAuthenticated, companyId, branchId, userId, logout, token } = useAuth();
    const [isLoading, setIsLoading] = useState(false);

    // Logout if token is expired
    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, token, logout]);

    const [selectedItemCategory, setSelectedItemCategory] = useState("");
    const [dropdownItemCategoryOptions, setDropdownItemCategoryOptions] = useState([]);

    const [isSubmit, setIsSubmit] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [IsMrpl, setIsMrpl] = useState("");
    const [HasWarranty, setHasWarranty] = useState("");
    const [IsReturnable, setIsReturnable] = useState("");
    const [WarrantyDays, setWarrantyDays] = useState("0");
    const [ReturnDays, setReturnDays] = useState("0");

    const [formData, setFormData] = useState({
        Code: '',
        SearchableName: '',
        Name: '',
        CGSTRate: '0',
        SGSTRate: '0',
        HSNCode: '',
        MRP: '0',
        PurchaseRate: '0',
        SaleRate: '0',
    });


    //  Item Category

    const [CategoryTypeOptions, setCategoryTypeOptions] = useState([]);
    const [selectedCategoryType, setSelectedCategoryType] = useState("");

    const fetchCategoryType = async () => {
        try {

            const response = await fetchData('ItemCategoryApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(category => ({
                    value: category.Id,
                    label: category.Name
                }));
                setCategoryTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };
    const handleCategoryTypeChange = (selectedOption) => {
        //setSelectedMasterType(selectedOption);
        setSelectedCategoryType(selectedOption);
    };

    useEffect(() => {
        fetchCategoryType();
    }, []);


    // Supplier

    const [SupplierTypeOptions, setSupplierTypeOptions] = useState([]);
    const [selectedSupplierType, setSelectedSupplierType] = useState("");

    const fetchSupplierType = async () => {
        try {

            const response = await fetchData('SupplierAndCustomerApi', `/${companyId}/2`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(supplier => ({
                    value: supplier.masterId,
                    label: supplier.name
                }));
                setSupplierTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };
    const handleSupplierTypeChange = (selectedOption) => {
        //setSelectedMasterType(selectedOption);
        setSelectedSupplierType(selectedOption);
    };

    useEffect(() => {
        fetchSupplierType();
    }, []);

    // UOM (UNIT OF MEASURES)

    const [MEASURESTypeOptions, setMEASURESTypeOptions] = useState([]);
    const [selectedMEASURESType, setSelectedMEASURESType] = useState("");

    const fetchMEASURESType = async () => {
        try {

            const response = await fetchData('UOMApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(uom => ({
                    value: uom.Id,
                    label: uom.Name
                }));
                setMEASURESTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };
    const handleMEASURESTypeChange = (selectedOption) => {
        //setSelectedMasterType(selectedOption);
        setSelectedMEASURESType(selectedOption);
    };

    useEffect(() => {
        fetchMEASURESType();
    }, []);


    const handleChange = (event) => {
        const { name, value, type } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? !prevData[name] : value,
        }));
    };

    const [ProfitType, setProfitType] = useState(true);

    const handleProfitchange = (e) => {
        const value = e.target.value === "true";
        setProfitType(value);
    };

    //customer
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    const closeModal = () => {
        setOpen(false);
    };

    // supplier 
    const [supplieropen, setSupplierOpen] = useState(false);

    const handleClickSupplierOpen = () => {
        setSupplierOpen(true);
    };

    const handleSupplierClose = () => {
        setSupplierOpen(false);
    };
    const closeSupplierModal = () => {
        setSupplierOpen(false);
    };

    // Customer

    const [CustomerTypeOptions, setCustomerTypeOptions] = useState([]);
    const [selectedCustomerType, setSelectedCustomerType] = useState("");
    const [selectedCustomerTypeId, setSelectedCustomerTypeId] = useState("");

    const fetchCustomerType = async () => {
        try {

            const response = await fetchData('SupplierAndCustomerApi', `/${companyId}/2`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(customer => ({
                    value: customer.masterId,
                    label: customer.name
                }));
                setCustomerTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };
    const handleCustomerTypeChange = (selectedOption) => {
        //setSelectedMasterType(selectedOption);
        setSelectedCustomerType(selectedOption);
        setSelectedCustomerTypeId(selectedOption.value);
    };

    useEffect(() => {
        fetchCustomerType();
    }, []);



    const [CustomerRateRelation, setCustomerRateRelation] = useState([]);
    const [FreightAmount, setFreightAmount] = useState("");
    const [MinProfitRate, setMinProfitRate] = useState("");
    const [MaxProfitRate, setMaxProfitRate] = useState("");
    const [ProfitTypeChild, setProfitTypeChild] = useState(true);

    // Handle radio button change
    const handleProfitchildchange = (value) => {
        setProfitTypeChild(value);  // Assuming you are using useState to set the state
    };

    // Handle form submission
    const handleSubmit = () => {
        const newSlab = {
            selectedCustomerType: selectedCustomerType.label,
            selectedCustomerTypeId: selectedCustomerType.value,
            MaxProfitRate,
            FreightAmount,
            MinProfitRate,
            ProfitTypeChild, // Add ProfitTypeChild (Percentage/Amount)
        };

        setCustomerRateRelation([...CustomerRateRelation, newSlab]); // Add new slab to the list

        // Clear the form
        setFreightAmount('');
        setMinProfitRate('');
        setMaxProfitRate('');
        setProfitTypeChild('Per');
        setSelectedCustomerType("");

        // Close the modal
        handleClose();
    };

    const [SupplierRateRelation, setSupplierRateRelation] = useState([]);
    // supplier handle submit 
    const handlesupplierSubmit = () => {
        const newSlab = {
            selectedCustomerType: selectedCustomerType.label,
            selectedCustomerTypeId: selectedCustomerType.value,
        };

        setSupplierRateRelation([...SupplierRateRelation, newSlab]); // Add new slab to the list

        // Clear the form
        setSelectedCustomerType("");

        // Close the modal
        handleClose();
    };

    const [selectedSlab, setSelectedSlab] = useState(null);
    const [editMode, setEditMode] = useState(false);

    const handleEdit = (slab) => {

        setSelectedSlab(slab);
        setEditMode(true);
    };

    const handleDelete = (index) => {
        const updatedRateRelation = CustomerRateRelation.filter((_, i) => i !== index);
        setCustomerRateRelation(updatedRateRelation);
    };

    

    const submitData = async () => {
        try {
            // Fetch existing data
            const existingItems = await fetchData('ItemApi', `/${companyId}`, token);
            console.log('Existing Items:', existingItems);

            if (
                existingItems.response_data && 
                Array.isArray(existingItems.response_data) &&
                existingItems.response_data.some(
                    (item) => item.Name === formData.Name || item.Code === formData.Code
                )
            ) {
                alert('Item with the same Name or Code already exists.');
                return;
            }

            // Validate form data
            if (!formData || !formData.Name || !formData.Code) {
                alert('Name and Code are required fields.');
                return;
            }
            if (!selectedCategoryType || typeof selectedCategoryType !== 'object' || !selectedCategoryType.value) {
                alert('Please select a category.');
                return;
            }
            if (!selectedMEASURESType || typeof selectedMEASURESType !== 'object' || !selectedMEASURESType.value) {
                alert('Please select a unit of measure.');
                return;
            }

            // Prepare data
            const ItemData = {
                CompanyId: companyId,
                ItemCategoryId: selectedCategoryType?.value,
                UnitofMeasureId: selectedMEASURESType?.value,
                Name: formData.Name,
                Code: formData.Code,
                CGSTRate: formData.CGSTRate,
                SGSTRate: formData.SGSTRate,
                PurchaseRate: formData.PurchaseRate,
                SaleRate: formData.SaleRate,
                MRP: formData.MRP,
                BarCode: formData.BarCode,
                HSNCode: formData.HSNCode,
                CreatedBy: userId,
                CreatedDate: new Date(),
            };

            // Submit data
            const response = await postData('ItemApi', ItemData, token);
            console.log('Data Created success:', response);

            history.push('/ItemIndex');
        } catch (error) {
            console.error('Error:', error);
            alert('An error occurred. Please try again.');
        }
    };

  
    
    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-6 mx-auto" style={{ minWidth: '101%' }}>
                <form onSubmit={submitData}>
                    <div className='w-full mb-2 flex'>
                        <h6 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>Item Create</h6>

                        <Button
                            style={{ marginLeft: '8px', color: 'darkgreen', fontWeight: 'bolder', marginTop: '-30px' }}
                            onClick={submitData}
                            disabled={isLoading}
                        >
                            <DoneIcon style={{ color: 'darkgreen', fontWeight: 'bolder' }} />
                            {isLoading ? <CircularProgress size={24} color="inherit" /> : <b>SAVE</b>}
                        </Button>

                        <Button
                            component={Link}
                            to="/ItemIndex"
                            className="linkcolor"
                            style={{ marginLeft: '8px', color: 'brown', fontWeight: 'bolder', marginTop: '-30px' }}
                        >
                            <ReplyAllIcon style={{ marginLeft: '8px', color: 'brown', fontWeight: 'bolder' }} /> BACK TO LIST
                        </Button>
                    </div>

                    {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                    {successMessage && <p className="text-green-500">{successMessage}</p>}

                    <div className="watermark">
                        <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                    </div>
                  

                    <div className="w-full flex flex-wrap">
                        <div className="w-full" style={{ padding: '7px', borderRadius: '10px', marginTop: '-10px' }}>
                            <div className="w-full mb-3 flex" >
                                <div className="w-1/8 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        Code<span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.Code}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Code"
                                        name='Code'
                                        onClick={(e) => e.target.select()}
                                    />
                                </div>
                                <div className="w-1/2 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        Name<span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.Name}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Name"
                                        name='Name'
                                        onClick={(e) => e.target.select()}
                                    />
                                </div>

                                <div className="w-1/3 mr-2">

                                    <label className="block uppercase tracking-wide  text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                        Category
                                    </label>

                                    <Select
                                        value={selectedCategoryType}
                                        onChange={handleCategoryTypeChange}
                                        options={CategoryTypeOptions}
                                        placeholder="Category"
                                        isSearchable
                                    />
                                </div>
                                <div className="w-1/6 mr-2">

                                    <label className="block uppercase tracking-wide  text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                        UOM
                                    </label>

                                    <Select
                                        value={selectedMEASURESType}
                                        onChange={handleMEASURESTypeChange}
                                        options={MEASURESTypeOptions}
                                        placeholder="UOM"
                                        isSearchable
                                    />

                                </div>

                            </div>

                            <div className="w-full mb-3 flex" style={{ marginTop: '10px' }}>


                                <div className="w-1/8 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        CGST Rate<span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.CGSTRate}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="CGST Rate"
                                        style={{ textAlign: 'right' }}
                                        name='CGSTRate'
                                        onClick={(e) => e.target.select()}
                                    />
                                </div>

                                <div className="w-1/8 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        SGST Rate<span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.SGSTRate}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="SGST Rate"
                                        style={{ textAlign: 'right' }}
                                        name='SGSTRate'
                                        onClick={(e) => e.target.select()}
                                    />
                                </div>
                                <div className="w-1/8 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        HSN Code<span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.HSNCode}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="HSN Code"
                                        name='HSNCode'
                                        onClick={(e) => e.target.select()}
                                    />
                                </div>
                                <div className="w-1/8 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        Purchase Rate<span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.PurchaseRate}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Purchase Rate"
                                        style={{ textAlign: 'right' }}
                                        name='PurchaseRate'
                                        onClick={(e) => e.target.select()}
                                    />
                                </div>

                                <div className="w-1/8 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        Sale Rate<span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.SaleRate}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Sale Rate"
                                        style={{ textAlign: 'right' }}
                                        name='SaleRate'
                                        onClick={(e) => e.target.select()}
                                    />
                                </div>
                                <div className="w-1/8 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        MRP<span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.MRP}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="MRP"
                                        style={{ textAlign: 'right' }}
                                        name='MRP'
                                        onClick={(e) => e.target.select()}
                                    />
                                </div>
                                <div className="w-1/8 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        Bar Code<span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.BarCode}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Bar Code"
                                        style={{ textAlign: 'right' }}
                                        name='BarCode'
                                        onClick={(e) => e.target.select()}
                                    />
                                </div>

                            </div>

                        </div>
                    </div>
                </form>
            </div >
        </Fragment >
    );
};

export default ItemCreate;

